import { createTheme } from '@mui/material/styles';
import { A11yContrast } from './store/mainSlice';

export const theme4dTokens = {
    bg: '#f4fafe',
    text: '#0c2e42',
    muted: '#5c7d90',
    border: '#d5e8f2',
    surface: '#ffffff',
    accent: '#0e93cf',
    accentText: '#ffffff',
    accentSoft: '#e2f2fb',
    badgeBg: '#fdeeba',
    badgeText: '#a97b12',
    radius: '18px',
    shadow: '0 16px 48px rgba(14,147,207,.20)',
    headFont: 'Rubik, sans-serif',
    font: 'Heebo, sans-serif',
};

// High-contrast counterpart of theme4dTokens: near-black/white with a bright blue accent —
// the classic OS-level "high contrast" palette (max luminance delta, white outlines instead
// of soft shadows, no decorative gradients), matching the same "high contrast -> dark mode +
// solid dark background" effect PassSignUp applies, but tuned for real legibility.
export const highContrastTokens = {
    ...theme4dTokens,
    bg: '#000000',
    text: '#ffffff',
    muted: '#d8d8d8',
    border: '#ffffff',
    surface: '#000000',
    accent: '#48b3ff',
    accentText: '#000000',
    accentSoft: '#0a3a55',
    badgeBg: '#48b3ff',
    badgeText: '#000000',
    shadow: 'none',
};

export const getA11yTokens = (contrast: A11yContrast) => (contrast === 'high' ? highContrastTokens : theme4dTokens);

export const createTheme4d = (direction: 'rtl' | 'ltr', contrast: A11yContrast = 'normal') => {
    const isHighContrast = contrast === 'high';
    const tokens = getA11yTokens(contrast);
    return createTheme({
        direction,
        palette: {
            mode: isHighContrast ? 'dark' : 'light',
            primary: { main: tokens.accent, contrastText: tokens.accentText },
            background: { default: tokens.bg, paper: tokens.surface },
            text: { primary: tokens.text, secondary: tokens.muted },
        },
        typography: {
            fontFamily: tokens.font,
        },
        shape: {
            borderRadius: 18,
        },
    });
};

const theme4d = createTheme4d('rtl');

export default theme4d;
